(function () {
  function openVideoFullscreen(video, stopAutoplay, startAutoplay) {
    if (!video) return;

    stopAutoplay();

    video.muted = false;
    video.loop = false;
    video.controls = true;
    video.currentTime = 0;
    video.volume = 1;

    function playVideo() {
      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    /* iPhone / iPad Safari native fullscreen */
    if (typeof video.webkitEnterFullscreen === 'function') {
      playVideo();

      try {
        video.webkitEnterFullscreen();
      } catch (error) {}

      return;
    }

    /* Standard fullscreen */
    if (typeof video.requestFullscreen === 'function') {
      video.requestFullscreen()
        .then(function () {
          playVideo();
        })
        .catch(function () {
          playVideo();
        });

      return;
    }

    /* Fallback: just play with controls + sound */
    playVideo();
  }

  function resetVideoPreview(video, startAutoplay) {
    if (!video) return;

    video.controls = false;
    video.loop = true;
    video.muted = true;
    video.volume = 1;

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }

    startAutoplay();
  }

  function initHeroSlider(root) {
    if (!root || root.dataset.drhsInit === 'true') return;

    root.dataset.drhsInit = 'true';

    var wrap = root.querySelector('[data-drhs]');
    var track = root.querySelector('[data-drhs-track]');
    var slides = Array.from(root.querySelectorAll('.drhs-slide'));
    var prevBtn = root.querySelector('[data-drhs-prev]');
    var nextBtn = root.querySelector('[data-drhs-next]');
    var dotsWrap = root.querySelector('[data-drhs-dots]');
    var videos = Array.from(root.querySelectorAll('.js-about-video'));

    if (!wrap || !track || !slides.length) return;

    var autoplayMs = parseInt(wrap.dataset.autoplayMs || '15000', 10);
    var pauseOnHover = wrap.dataset.pauseOnHover === 'true';

    if (!autoplayMs || autoplayMs < 1000) {
      autoplayMs = 15000;
    }

    var index = 0;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
      dotsWrap.innerHTML = '';

      dots = slides.map(function (_, slideIndex) {
        var button = document.createElement('button');

        button.type = 'button';
        button.className = 'drhs-dot';
        button.setAttribute('aria-label', 'Go to slide ' + (slideIndex + 1));

        button.addEventListener('click', function () {
          goTo(slideIndex, true);
        });

        dotsWrap.appendChild(button);

        return button;
      });
    }

    function updateUI() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';

      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });

      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
    }

    function goTo(slideIndex, userAction) {
      index = (slideIndex + slides.length) % slides.length;
      updateUI();

      if (userAction) {
        restartAutoplay();
      }
    }

    function next(userAction) {
      goTo(index + 1, userAction);
    }

    function prev(userAction) {
      goTo(index - 1, userAction);
    }

    function startAutoplay() {
      stopAutoplay();

      if (slides.length < 2) return;

      timer = window.setInterval(function () {
        next(false);
      }, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
      }

      timer = null;
    }

    function restartAutoplay() {
      startAutoplay();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next(true);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev(true);
      });
    }

    wrap.setAttribute('tabindex', '0');

    wrap.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        next(true);
      }

      if (event.key === 'ArrowLeft') {
        prev(true);
      }
    });

    if (pauseOnHover) {
      wrap.addEventListener('mouseenter', function () {
        stopAutoplay();
      });

      wrap.addEventListener('mouseleave', function () {
        startAutoplay();
      });
    }

    videos.forEach(function (video) {
      var openHandler = function (event) {
        event.preventDefault();
        event.stopPropagation();
        openVideoFullscreen(video, stopAutoplay, startAutoplay);
      };

      video.addEventListener('click', openHandler);
      video.addEventListener('touchend', openHandler);

      video.addEventListener('webkitendfullscreen', function () {
        resetVideoPreview(video, startAutoplay);
      });

      video.addEventListener('ended', function () {
        if (!document.fullscreenElement) {
          resetVideoPreview(video, startAutoplay);
        }
      });
    });

    document.addEventListener('fullscreenchange', function () {
      if (!document.fullscreenElement) {
        videos.forEach(function (video) {
          resetVideoPreview(video, startAutoplay);
        });
      }
    });

    updateUI();
    startAutoplay();
  }

  function initAllHeroSliders(container) {
    var scope = container || document;
    var sliders = Array.from(scope.querySelectorAll('[data-drhs-root]'));

    sliders.forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHeroSliders(document);
    });
  } else {
    initAllHeroSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroSliders(event.target);
  });
})();